angular.module('client-feature')
    .controller('ClientFeatureDialogController', function ($rootScope, $uibModalInstance, data, toastr, ClientFeature, ClientFeatureConst) {
        this.$onInit = () => {
            this.item = data
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = ClientFeature.update(this.item).$promise
            } else {
                $promise = ClientFeature.save(this.item).$promise
            }
            $promise.then(result => {
                $rootScope.$broadcast(ClientFeatureConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
            return $promise
        }
    })
